import request from '../config/axiosConfig';
import { CREATE_PERMISSION, DELETE_PERMISSION, GET_LIST_PERMISSION_GROUP, GET_LIST_PERMISSIONS, UPDATE_PERMISSION } from '../constants/apiEndPoint';

export const getListPermissionsRequest = async (data) => {
  const result = await request({
    url: GET_LIST_PERMISSIONS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const getListPermissionsGroupRequest = async (data) => {
  const result = await request({
    url: GET_LIST_PERMISSION_GROUP,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const createPermissionRequest = async (data) => {
  const result = await request({
    url: CREATE_PERMISSION,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updatePermissionRequest = async (data) => {
  const result = await request({
    url: UPDATE_PERMISSION,
    method: 'PUT',
    data,
  });
  return result?.data;
};

export const deletePermissionRequest = async (data) => {
  const result = await request({
    url: DELETE_PERMISSION,
    method: 'DELETE',
    data,
  });
  return result?.data;
};
